(() => {
'use strict';
const configElement=document.getElementById('bardo-theme-config');
if(!configElement) return;
let CONFIG={assets:{},products:{}};
try{CONFIG=JSON.parse(configElement.textContent);}catch(error){console.error('Bardo theme configuration could not be read.',error);return;}
const PRODUCTS = {
  umber: {name:'Umber', code:'BS-01 / UMBER', price:129,
    imgs:[CONFIG.assets["bardo-image-10.jpg"],CONFIG.assets["bardo-image-11.jpg"],CONFIG.assets["bardo-image-12.jpg"]],
    desc:"Deep brushed suede in near-black brown, stacked lug sole, speed-hook eyelets built for fast relacing. Strung here in white and braided tan — change the laces, change the shoe."},
  slate: {name:'Slate', code:'BS-02 / SLATE', price:129,
    imgs:[CONFIG.assets["bardo-image-13.jpg"],CONFIG.assets["bardo-image-14.jpg"],CONFIG.assets["bardo-image-15.jpg"]],
    desc:"Cool charcoal suede on the same stacked sole and speed-hook eyelets. Strung in soft mint for a quiet contrast, or swap in black for something closer to shadow."},
  dune: {name:'Dune', code:'BS-03 / DUNE', price:129,
    imgs:[CONFIG.assets["bardo-image-16.jpg"],CONFIG.assets["bardo-image-17.jpg"],CONFIG.assets["bardo-image-18.jpg"]],
    desc:"Warm, sanded suede in a soft taupe. Same silhouette, same sole, strung in white and braided tan for a lighter, dressed-down look."},
  clay: {name:'Clay', code:'BS-04 / CLAY', price:129,
    imgs:[CONFIG.assets["bardo-image-19.jpg"],CONFIG.assets["bardo-image-20.jpg"],CONFIG.assets["bardo-image-21.jpg"]],
    desc:"Brushed suede in a warm burnt clay, finished with the same lugged sole. Strung in pink for contrast that doesn't ask permission."}
};
const ORDER=['umber','slate','dune','clay'];
const SIZES=[
  {eu:38,uk:5.5,men:6,women:7.5,cm:'24.0'},
  {eu:39,uk:6,men:6.5,women:8,cm:'24.7'},
  {eu:40,uk:6.5,men:7,women:8.5,cm:'25.3'},
  {eu:40.5,uk:7,men:7.5,women:9,cm:'25.7'},
  {eu:41,uk:7.5,men:8,women:9.5,cm:'26.0'},
  {eu:42,uk:8,men:8.5,women:10,cm:'26.7'},
  {eu:42.5,uk:8.5,men:9,women:10.5,cm:'27.0'},
  {eu:43,uk:9,men:9.5,women:11,cm:'27.3'},
  {eu:44,uk:9.5,men:10,women:11.5,cm:'28.0'},
  {eu:45,uk:10.5,men:11,women:12.5,cm:'28.7'},
  {eu:46,uk:11.5,men:12,women:13.5,cm:'29.3'}
];

// Add the real myshopify.com domain and Shopify variant IDs here when available.
const SHOPIFY_CONFIG={storeDomain:CONFIG.storeDomain||'',products:CONFIG.products||{umber:[],slate:[],dune:[],clay:[]}};
const REVIEW_STORAGE_KEY='bardo-static-customer-reviews-v1';
let bagCount=0, selectedSize=null, currentProductId=null, sizeSystem='us';
let reviewRating=0, reviewPhotos=[], reviewFilter='all', reviewCache=[], memoryReviews=[];

function updateLogo(){
  const h=document.getElementById('siteHeader');
  const light = h.classList.contains('home') && !h.classList.contains('scrolled');
  document.getElementById('logoImg').src = light ? CONFIG.assets["bardo-image-01.png"] : CONFIG.assets["bardo-image-09.png"];
}

function showView(name){
  document.querySelectorAll('.view').forEach(v=>v.classList.remove('active'));
  document.getElementById('view-'+name).classList.add('active');
  window.scrollTo(0,0);
  const header=document.getElementById('siteHeader');
  header.classList.toggle('home', name==='home');
  header.classList.toggle('solid', name!=='home');
  header.classList.remove('scrolled');
  document.querySelectorAll('.main-nav a').forEach(a=>a.classList.toggle('current', a.dataset.nav===name));
  updateLogo();
  closeMobileNav();
}

function buildShopGrid(){
  const grid=document.getElementById('shopGrid');
  grid.innerHTML='';
  ORDER.forEach(id=>{
    const p=PRODUCTS[id];
    const card=document.createElement('a');
    card.className='product-card';
    card.href='/products/'+id;
    card.setAttribute('aria-label',p.name+', $'+p.price+' — view product');
    card.style.textDecoration='none';
    card.style.color='inherit';
    card.style.display='block';
    card.onclick=(e)=>{
      if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return;
      e.preventDefault();
      openProduct(id);
    };
    card.innerHTML=`<div class="card-media"><img src="${p.imgs[0]}" alt="${p.name}"><img class="img-hover" src="${p.imgs[1]}" alt="${p.name} detail"></div>
      <div class="card-info"><div><h3>${p.name}</h3><div class="card-code">${p.code}</div></div><div class="card-price">$${p.price}</div></div>
      <div class="card-cta" style="margin-top:10px;font-family:'IBM Plex Mono',monospace;font-size:.72rem;letter-spacing:.08em;text-transform:uppercase;opacity:.7">View →</div>`;
    grid.appendChild(card);
  });
}

function openProduct(id){
  selectedSize=null;
  currentProductId=id;
  sizeSystem='us';
  const p=PRODUCTS[id];
  document.getElementById('galleryMain').src=p.imgs[0];
  const thumbs=document.getElementById('galleryThumbs');
  thumbs.innerHTML='';
  p.imgs.forEach((src,i)=>{
    const t=document.createElement('img');
    t.src=src; t.alt=p.name+' view '+(i+1);
    if(i===0) t.classList.add('active');
    t.onclick=()=>{document.getElementById('galleryMain').src=src;
      thumbs.querySelectorAll('img').forEach(x=>x.classList.remove('active')); t.classList.add('active');};
    thumbs.appendChild(t);
  });
  document.getElementById('productCode').textContent=p.code;
  document.getElementById('productTitle').textContent=p.name;
  document.getElementById('productPrice').textContent='$'+p.price;
  document.getElementById('productDesc').textContent=p.desc;
  updateProductRating(id);
  renderSizeOptions();
  document.getElementById('sizeWarn').textContent='';
  document.getElementById('addBagBtn').textContent='Select a size';
  document.getElementById('addBagBtn').classList.remove('ready');
  showView('product');
}

function setSizeSystem(system){
  sizeSystem=system;
  renderSizeOptions();
}

function renderSizeOptions(){
  const sizeGrid=document.getElementById('sizeGrid');
  sizeGrid.innerHTML='';
  document.getElementById('sizeSystemUS').classList.toggle('active',sizeSystem==='us');
  document.getElementById('sizeSystemEU').classList.toggle('active',sizeSystem==='eu');
  document.getElementById('sizeSystemNote').textContent=sizeSystem==='us'
    ? "US men's sizing · women's equivalent shown"
    : "EU sizing · US equivalents shown";
  const variants=SHOPIFY_CONFIG.products[currentProductId]||[];
  const choices=variants.length
    ? variants.map(variant=>{
        const raw=(variant.options||[])[0]??variant.title;
        const men=Number.parseFloat(String(raw));
        return {size:SIZES.find(size=>size.men===men)||{eu:'—',uk:'—',men:raw,women:'—',cm:'—'},variant};
      })
    : SIZES.map(size=>({size,variant:null}));
  choices.forEach(({size:s,variant})=>{
    const b=document.createElement('button');
    b.className='size-btn size-option';
    b.type='button';
    b.innerHTML=sizeSystem==='us'
      ? '<span class="size-main">US '+s.men+'</span><span class="size-alt">Women '+s.women+'</span>'
      : '<span class="size-main">EU '+s.eu+'</span><span class="size-alt">US M '+s.men+' · W '+s.women+'</span>';
    b.setAttribute('aria-label','EU '+s.eu+', US men '+s.men+', US women '+s.women);
    if(variant&&!variant.available){
      b.disabled=true;
      b.classList.add('sold-out');
      b.setAttribute('aria-label',b.getAttribute('aria-label')+', sold out');
    }
    if(selectedSize&&(
      (variant&&String(selectedSize.variantId)===String(variant.id))||
      (!variant&&selectedSize.men===s.men)
    )) b.classList.add('selected');
    b.onclick=()=>{
      selectedSize={...s,variantId:variant?.id||null};
      renderSizeOptions();
      document.getElementById('sizeWarn').textContent='';
      const action=document.getElementById('addBagBtn');
      action.textContent='Add to cart';
      action.classList.add('ready');
    };
    sizeGrid.appendChild(b);
  });
}

function normalizedSize(value){
  return String(value??'').toLowerCase().replace(/[^a-z0-9.]/g,'');
}

function findShopifyVariant(productId,size){
  const variants=SHOPIFY_CONFIG.products[productId]||[];
  if(size.variantId){
    return variants.find(variant=>variant.available&&String(variant.id)===String(size.variantId))||null;
  }
  const candidates=new Set([
    String(size.eu), 'eu'+size.eu,
    String(size.men), 'us'+size.men, 'usmen'+size.men, 'men'+size.men
  ].map(normalizedSize));
  return variants.find(variant=>variant.available && (variant.options||[]).some(option=>candidates.has(normalizedSize(option))))||null;
}

async function sendToShopifyCart(){
  const variants=SHOPIFY_CONFIG.products[currentProductId]||[];
  if(!variants.length){
    document.getElementById('sizeWarn').textContent='This colorway is not connected to Shopify yet.';
    return true;
  }
  const variant=findShopifyVariant(currentProductId,selectedSize);
  if(!variant){
    document.getElementById('sizeWarn').textContent='This size is not connected to an available Shopify variant yet.';
    return true;
  }
  const button=document.getElementById('addBagBtn');
  const originalLabel=button.textContent;
  button.disabled=true;
  button.textContent='Adding…';
  try{
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const response=await fetch(root+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(variant.id),quantity:1}]})
    });
    const payload=await response.json().catch(()=>({}));
    if(!response.ok){
      throw new Error(payload.description||payload.message||'Shopify could not add this size to the cart.');
    }
    window.location.assign(root+'cart');
  }catch(error){
    document.getElementById('sizeWarn').textContent=error.message||'The item could not be added. Please try again.';
    button.disabled=false;
    button.textContent=originalLabel;
  }
  return true;
}

async function handleProductAction(){
  if(!selectedSize){
    document.getElementById('sizeWarn').textContent='Choose a size to continue.';
    document.getElementById('sizeGrid').scrollIntoView({behavior:'smooth',block:'center'});
    return;
  }
  const handledByShopify=await sendToShopifyCart();
  if(!handledByShopify) addToCart();
}

function addToCart(){
  bagCount=1; document.getElementById('bagCount').textContent=bagCount;
  const p=PRODUCTS[currentProductId];
  document.getElementById('checkoutImage').src=p.imgs[0];
  document.getElementById('checkoutImage').alt=p.name;
  document.getElementById('checkoutName').textContent=p.name;
  document.getElementById('checkoutSize').textContent='US Men '+selectedSize.men+' · US Women '+selectedSize.women+' · EU '+selectedSize.eu;
  document.getElementById('checkoutPrice').textContent='$'+p.price;
  showView('checkout');
}

function starString(rating){
  const rounded=Math.max(0,Math.min(5,Math.round(rating)));
  return '★'.repeat(rounded)+'☆'.repeat(5-rounded);
}

function getAllReviews(){
  try{
    const stored=JSON.parse(localStorage.getItem(REVIEW_STORAGE_KEY)||'[]');
    return Array.isArray(stored)?stored:[];
  }catch(error){
    return memoryReviews.slice();
  }
}

function saveAllReviews(reviews){
  memoryReviews=reviews.slice();
  try{
    localStorage.setItem(REVIEW_STORAGE_KEY,JSON.stringify(reviews));
    return true;
  }catch(error){
    return false;
  }
}

function reviewsForProduct(productId){
  return getAllReviews().filter(review=>review.productId===productId).sort((a,b)=>new Date(b.date)-new Date(a.date));
}

async function updateProductRating(productId){
  const reviews=reviewsForProduct(productId);
  const average=reviews.length?reviews.reduce((sum,review)=>sum+review.rating,0)/reviews.length:0;
  document.getElementById('productRatingStars').textContent=starString(average);
  document.getElementById('productRatingText').textContent=reviews.length
    ? average.toFixed(1)+' · '+reviews.length+' review'+(reviews.length===1?'':'s')
    : 'No reviews yet · Write the first';
}

async function openReviews(){
  if(!currentProductId) return;
  const product=PRODUCTS[currentProductId];
  document.getElementById('reviewsProductImage').src=product.imgs[0];
  document.getElementById('reviewsProductImage').alt=product.name;
  document.getElementById('reviewsProductName').textContent=product.name;
  document.getElementById('reviewsProductPrice').textContent='$'+product.price;
  reviewFilter='all';
  document.getElementById('reviewFilter').value='all';
  showView('reviews');
  await refreshReviews();
}

async function refreshReviews(){
  reviewCache=reviewsForProduct(currentProductId);
  const count=reviewCache.length;
  const average=count?reviewCache.reduce((sum,review)=>sum+review.rating,0)/count:0;
  document.getElementById('reviewsAverage').textContent=count?average.toFixed(1):'0.0';
  document.getElementById('reviewsAverageStars').textContent=starString(average);
  document.getElementById('reviewsCount').textContent=count
    ? count+' verified customer review'+(count===1?'':'s')
    : 'No reviews yet';
  renderRatingBreakdown();
  renderCustomerPhotos();
  renderReviewList();
  await updateProductRating(currentProductId);
}

function renderRatingBreakdown(){
  const container=document.getElementById('ratingBreakdown');
  container.innerHTML='';
  for(let rating=5;rating>=1;rating--){
    const count=reviewCache.filter(review=>review.rating===rating).length;
    const percent=reviewCache.length?Math.round((count/reviewCache.length)*100):0;
    const row=document.createElement('div');
    row.className='rating-row';
    const label=document.createElement('span');
    label.textContent=rating+' star';
    const track=document.createElement('span');
    track.className='rating-track';
    const fill=document.createElement('span');
    fill.className='rating-fill';
    fill.style.width=percent+'%';
    track.appendChild(fill);
    const value=document.createElement('span');
    value.textContent=count;
    row.append(label,track,value);
    container.appendChild(row);
  }
}

function allCustomerPhotos(){
  return reviewCache.flatMap(review=>(review.photos||[]).map(src=>({src,author:review.author})));
}

function renderCustomerPhotos(){
  const photos=allCustomerPhotos();
  const section=document.getElementById('customerPhotosSection');
  const grid=document.getElementById('customerPhotoGrid');
  grid.innerHTML='';
  section.hidden=photos.length===0;
  photos.slice(0,10).forEach(photo=>{
    const button=document.createElement('button');
    button.type='button';
    button.setAttribute('aria-label','Open customer photo by '+photo.author);
    const image=document.createElement('img');
    image.src=photo.src;
    image.alt='Customer photo by '+photo.author;
    button.appendChild(image);
    button.onclick=()=>openReviewPhoto(photo.src,photo.author);
    grid.appendChild(button);
  });
}

function setReviewFilter(filter){
  reviewFilter=filter;
  renderReviewList();
}

function filteredReviews(){
  if(reviewFilter==='photos') return reviewCache.filter(review=>(review.photos||[]).length);
  if(reviewFilter==='all') return reviewCache;
  return reviewCache.filter(review=>review.rating===Number(reviewFilter));
}

function renderReviewList(){
  const list=document.getElementById('reviewList');
  const empty=document.getElementById('reviewEmpty');
  const reviews=filteredReviews();
  list.innerHTML='';
  empty.hidden=reviews.length>0;
  if(!reviews.length){
    empty.querySelector('h3').textContent=reviewCache.length?'No matching reviews':'No reviews yet';
    empty.querySelector('p').textContent=reviewCache.length
      ? 'Try another filter to see more customer feedback.'
      : 'Be the first to share how your pair fits, feels, and wears.';
    return;
  }
  reviews.forEach(review=>{
    const card=document.createElement('article');
    card.className='review-card';
    const meta=document.createElement('div');
    meta.className='review-card-meta';
    const stars=document.createElement('span');
    stars.className='rating-stars';
    stars.textContent=starString(review.rating);
    const author=document.createElement('strong');
    author.textContent=review.author;
    const date=document.createElement('time');
    date.dateTime=review.date;
    date.textContent=new Intl.DateTimeFormat('en-US',{year:'numeric',month:'short',day:'numeric'}).format(new Date(review.date));
    meta.append(stars,author,date);
    const body=document.createElement('div');
    body.className='review-card-body';
    const title=document.createElement('h3');
    title.textContent=review.title;
    const copy=document.createElement('p');
    copy.textContent=review.body;
    body.append(title,copy);
    if((review.photos||[]).length){
      const photos=document.createElement('div');
      photos.className='review-card-photos';
      review.photos.forEach((src,index)=>{
        const button=document.createElement('button');
        button.type='button';
        button.setAttribute('aria-label','Open review photo '+(index+1));
        const image=document.createElement('img');
        image.src=src;
        image.alt='Review photo '+(index+1)+' by '+review.author;
        button.appendChild(image);
        button.onclick=()=>openReviewPhoto(src,review.author);
        photos.appendChild(button);
      });
      body.appendChild(photos);
    }
    card.append(meta,body);
    list.appendChild(card);
  });
}

function toggleReviewForm(open){
  const panel=document.getElementById('reviewFormPanel');
  panel.hidden=!open;
  if(open){
    document.getElementById('reviewFormMessage').textContent='';
    panel.scrollIntoView({behavior:'smooth',block:'start'});
    setTimeout(()=>document.getElementById('reviewName').focus(),350);
  }
}

function setReviewRating(rating){
  reviewRating=rating;
  document.querySelectorAll('#reviewStarPicker button').forEach(button=>{
    const active=Number(button.dataset.rating)<=rating;
    button.classList.toggle('active',active);
    button.textContent=active?'★':'☆';
    button.setAttribute('role','radio');
    button.setAttribute('aria-checked',Number(button.dataset.rating)===rating?'true':'false');
  });
}

function compressReviewImage(file){
  return new Promise((resolve,reject)=>{
    if(!file.type.startsWith('image/')) return reject(new Error('Only image files can be uploaded.'));
    if(file.size>8*1024*1024) return reject(new Error('Each image must be smaller than 8 MB.'));
    const objectUrl=URL.createObjectURL(file);
    const image=new Image();
    image.onload=()=>{
      URL.revokeObjectURL(objectUrl);
      const max=1100;
      const scale=Math.min(1,max/Math.max(image.width,image.height));
      const canvas=document.createElement('canvas');
      canvas.width=Math.round(image.width*scale);
      canvas.height=Math.round(image.height*scale);
      const context=canvas.getContext('2d');
      context.drawImage(image,0,0,canvas.width,canvas.height);
      resolve(canvas.toDataURL('image/jpeg',.72));
    };
    image.onerror=()=>{URL.revokeObjectURL(objectUrl);reject(new Error('This image could not be read.'));};
    image.src=objectUrl;
  });
}

function renderReviewUploadPreview(){
  const container=document.getElementById('reviewUploadPreview');
  container.innerHTML='';
  reviewPhotos.forEach((src,index)=>{
    const figure=document.createElement('figure');
    const image=document.createElement('img');
    image.src=src;
    image.alt='Upload preview '+(index+1);
    const remove=document.createElement('button');
    remove.type='button';
    remove.textContent='×';
    remove.setAttribute('aria-label','Remove photo '+(index+1));
    remove.onclick=()=>{reviewPhotos.splice(index,1);renderReviewUploadPreview();};
    figure.append(image,remove);
    container.appendChild(figure);
  });
}

function openReviewPhoto(src,author){
  const overlay=document.createElement('div');
  overlay.className='review-photo-lightbox';
  overlay.setAttribute('role','dialog');
  overlay.setAttribute('aria-label','Customer photo by '+author);
  const close=document.createElement('button');
  close.type='button';
  close.textContent='×';
  close.setAttribute('aria-label','Close customer photo');
  const image=document.createElement('img');
  image.src=src;
  image.alt='Customer photo by '+author;
  image.onclick=event=>event.stopPropagation();
  close.onclick=()=>overlay.remove();
  overlay.onclick=()=>overlay.remove();
  overlay.append(close,image);
  document.body.appendChild(overlay);
  close.focus();
}

function openSizeGuide(){
  const p=PRODUCTS[currentProductId];
  document.getElementById('sizeGuideImage').src=p.imgs[0];
  document.getElementById('sizeGuideProduct').textContent=p.name;
  document.getElementById('sizeGuideDrawer').classList.add('open');
  document.getElementById('sizeGuideOverlay').classList.add('open');
  document.getElementById('sizeGuideDrawer').setAttribute('aria-hidden','false');
  document.body.classList.add('drawer-open');
}

function closeSizeGuide(){
  document.getElementById('sizeGuideDrawer').classList.remove('open');
  document.getElementById('sizeGuideOverlay').classList.remove('open');
  document.getElementById('sizeGuideDrawer').setAttribute('aria-hidden','true');
  document.body.classList.remove('drawer-open');
}

function openMobileNav(){document.getElementById('mobileNav').classList.add('open');}
function closeMobileNav(){document.getElementById('mobileNav').classList.remove('open');}
function openBag(){
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  window.location.assign(root+'cart');
}

async function loadCartCount(){
  try{
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const response=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok) return;
    const cart=await response.json();
    bagCount=Number(cart.item_count)||0;
    document.getElementById('bagCount').textContent=bagCount;
  }catch(error){
    console.warn('Cart count could not be loaded.',error);
  }
}

window.addEventListener('scroll',()=>{
  const header=document.getElementById('siteHeader');
  if(header.classList.contains('home')){
    const wasScrolled = header.classList.contains('scrolled');
    const isScrolled = window.scrollY>60;
    if(wasScrolled!==isScrolled){ header.classList.toggle('scrolled', isScrolled); updateLogo(); }
  }
});

document.getElementById('contactForm')?.addEventListener('submit', e=>{
  e.preventDefault();
  document.getElementById('contactConfirm').style.display='block';
  e.target.reset();
});

document.getElementById('reviewPhotos')?.addEventListener('change',async event=>{
  const message=document.getElementById('reviewFormMessage');
  const available=3-reviewPhotos.length;
  const files=Array.from(event.target.files).slice(0,available);
  if(!available){
    message.textContent='You can upload up to 3 photos.';
    event.target.value='';
    return;
  }
  message.textContent='Preparing your photos…';
  for(const file of files){
    try{
      reviewPhotos.push(await compressReviewImage(file));
    }catch(error){
      message.textContent=error.message;
    }
  }
  renderReviewUploadPreview();
  if(reviewPhotos.length) message.textContent=reviewPhotos.length+' photo'+(reviewPhotos.length===1?'':'s')+' ready to upload.';
  event.target.value='';
});

document.getElementById('reviewForm')?.addEventListener('submit',async event=>{
  event.preventDefault();
  const message=document.getElementById('reviewFormMessage');
  if(!reviewRating){
    message.textContent='Choose a star rating before submitting.';
    document.getElementById('reviewStarPicker').focus();
    return;
  }
  const review={
    id:'review-'+Date.now()+'-'+Math.random().toString(36).slice(2,8),
    productId:currentProductId,
    rating:reviewRating,
    author:document.getElementById('reviewName').value.trim(),
    title:document.getElementById('reviewTitle').value.trim(),
    body:document.getElementById('reviewBody').value.trim(),
    photos:reviewPhotos.slice(),
    date:new Date().toISOString()
  };
  const all=getAllReviews();
  all.push(review);
  const persisted=saveAllReviews(all);
  event.target.reset();
  reviewPhotos=[];
  renderReviewUploadPreview();
  setReviewRating(0);
  await refreshReviews();
  message.textContent=persisted
    ? 'Thank you. Your review and photos have been published on this device.'
    : 'Your review is visible for this session, but this browser could not save it permanently.';
});

document.getElementById('checkoutForm')?.addEventListener('submit', e=>{
  e.preventDefault();
  const variants=SHOPIFY_CONFIG.products[currentProductId]||[];
  document.getElementById('checkoutStatus').textContent=variants.length
    ? 'Return to the product and choose an available size to open Shopify checkout.'
    : 'Connect this colorway to a Shopify product in the theme editor to activate secure checkout.';
});

document.addEventListener('keydown',e=>{if(e.key==='Escape') closeSizeGuide();});

Object.assign(window,{
  showView,openProduct,setSizeSystem,handleProductAction,openReviews,
  toggleReviewForm,setReviewRating,setReviewFilter,openSizeGuide,closeSizeGuide,
  openMobileNav,closeMobileNav,openBag
});

buildShopGrid();
if(CONFIG.initialProduct && PRODUCTS[CONFIG.initialProduct]){
  openProduct(CONFIG.initialProduct);
}else if(window.location.pathname.indexOf('/collections/')===0){
  showView('shop');
}else{
  showView(window.location.hash==='#shop'?'shop':'home');
}
loadCartCount();
})();
